/* app/js/src/components/mam-explorer/mam-explorer-name-cell/mam-explorer-name-cell.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  bottom: 4px;
  width: 100%;
  min-width: 0;
  overflow: hidden;
}
img {
  flex-shrink: 0;
}
span {
  color: rgba(0, 0, 0, 0.85);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceMappingURL=mam-explorer-name-cell.component.css.map */
